import { IFuncionario, IFuncionarioDetalhe } from "../../../../@interfaces";
import Subtitle from "../../../../components/subtitle";
import Text from "../../../../components/text";
import aux from "../../../../utils/auxiliar";
import { Container, InfoCell, InfoRow } from "./styles";



interface IGeralProps {
  data: IFuncionarioDetalhe;
}

const Geral: React.FC<IGeralProps> = ({ data }) => {
  return (
    <Container>
      <InfoRow columnTemplate="1fr 3fr 1fr 1fr 1fr">
        <InfoCell>
          <Subtitle className="!text-[1rem] !text-[rgba(0,0,0,.6)] !font-bold">RE</Subtitle>
          <div>
            <Text className="!text-[.875rem] !text-[rgba(0,0,0,.5)]">
              {data.re}
            </Text>
          </div>
        </InfoCell>
        <InfoCell>
          <Subtitle className="!text-[1rem] !text-[rgba(0,0,0,.6)] !font-bold">Nome completo</Subtitle>
          <div>
            <Text className="!text-[.875rem] !text-[rgba(0,0,0,.5)]">
              {data.nomeFuncionario}
            </Text>
          </div>
        </InfoCell>
        <InfoCell>
          <Subtitle className="!text-[1rem] !text-[rgba(0,0,0,.6)] !font-bold">CPF</Subtitle>
          <div>
            <Text className="!text-[.875rem] !text-[rgba(0,0,0,.5)]">
              {data.cpf}
            </Text>
          </div>
        </InfoCell>
        <InfoCell>
          <Subtitle className="!text-[1rem] !text-[rgba(0,0,0,.6)] !font-bold">RG</Subtitle>
          <div>
            <Text className="!text-[.875rem] !text-[rgba(0,0,0,.5)]">
              {data.rg}
            </Text>
          </div>
        </InfoCell>
        <InfoCell>
          <Subtitle className="!text-[1rem] !text-[rgba(0,0,0,.6)] !font-bold">Data de Nascimento</Subtitle>
          <div>
            <Text className="!text-[.875rem] !text-[rgba(0,0,0,.5)]">
              {aux.formatRawDateToDate(data.dataNascimento)}
            </Text>
          </div>
        </InfoCell>
      </InfoRow>
      <InfoRow columnTemplate="3fr 1fr 2fr 2fr 2fr 1fr">
        <InfoCell>
          <Subtitle className="!text-[1rem] !text-[rgba(0,0,0,.6)] !font-bold">Endereço</Subtitle>
          <div>
            <Text className="!text-[.875rem] !text-[rgba(0,0,0,.5)]">
              {data.endereco.logradouro}
            </Text>
          </div>
        </InfoCell>
        <InfoCell>
          <Subtitle className="!text-[1rem] !text-[rgba(0,0,0,.6)] !font-bold">Número</Subtitle>
          <div>
            <Text className="!text-[.875rem] !text-[rgba(0,0,0,.5)]">
              {data.endereco.numero}
            </Text>
          </div>
        </InfoCell>
        <InfoCell>
          <Subtitle className="!text-[1rem] !text-[rgba(0,0,0,.6)] !font-bold">Complemento</Subtitle>
          <div>
            <Text className="!text-[.875rem] !text-[rgba(0,0,0,.5)]">
              {data.endereco.complemento}
            </Text>
          </div>
        </InfoCell>
        <InfoCell>
          <Subtitle className="!text-[1rem] !text-[rgba(0,0,0,.6)] !font-bold">Bairro</Subtitle>
          <div>
            <Text className="!text-[.875rem] !text-[rgba(0,0,0,.5)]">
              {data.endereco.bairro}
            </Text>
          </div>
        </InfoCell>
        <InfoCell>
          <Subtitle className="!text-[1rem] !text-[rgba(0,0,0,.6)] !font-bold">Cidade</Subtitle>
          <div>
            <Text className="!text-[.875rem] !text-[rgba(0,0,0,.5)]">
              {data.endereco.cidade}
            </Text>
          </div>
        </InfoCell>
        <InfoCell>
          <Subtitle className="!text-[1rem] !text-[rgba(0,0,0,.6)] !font-bold">Estado</Subtitle>
          <div>
            <Text className="!text-[.875rem] !text-[rgba(0,0,0,.5)]">
              {data.endereco.uf}
            </Text>
          </div>
        </InfoCell>
      </InfoRow>
      <InfoRow columnTemplate="2fr 1fr 3fr">

        <InfoCell>
          <Subtitle className="!text-[1rem] !text-[rgba(0,0,0,.6)] !font-bold">Data de Admissão</Subtitle>
          <div>
            <Text className="!text-[.875rem] !text-[rgba(0,0,0,.5)]">
              {aux.formatRawDateToDate(data.dataAdmissao)}
            </Text>
          </div>
        </InfoCell>
      </InfoRow>
    </Container>
  )
}

export default Geral;
